import React from "react";

export default function PLOFoldTile() {
	return (
		<div className="plo-range-tile plo-be-indicator" key={`be-indicator`}>
			{"F "}
		</div>
	);
}
